package com.zq.webproject.model

import kotlinx.serialization.Serializable

@Serializable
data class ProductResponse(
    val success: Boolean,
    val data: Product?
)

@Serializable
data class Product(
    val id: Int,
    val name: String,
    val price: Double,
    val category: String,
    val imageUrl: String,
    val sales: Int,
    val views: Int,
    val description: String? = null,  // 改为可空，某些商品可能没有描述
    val status: Int? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null,
    val baiduUrl: String? = null,      // 百度网盘链接
    val extractCode: String? = null,   // 提取码
    val otherResources: List<Resource>? = null  // 其他资源列表
)

@Serializable
data class Resource(
    val name: String,
    val url: String
)

